/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Keyword_Optimizer_No_ReformulationsInputs */

const en_keyword_optimizer_no_reformulations = /** @type {(inputs: Keyword_Optimizer_No_ReformulationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All keywords are already present in your resume — no rewording needed.`)
};

const de_keyword_optimizer_no_reformulations = /** @type {(inputs: Keyword_Optimizer_No_ReformulationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Keywords sind bereits in deinem Lebenslauf vorhanden — keine Umformulierung nötig.`)
};

const fr_keyword_optimizer_no_reformulations = /** @type {(inputs: Keyword_Optimizer_No_ReformulationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tous les mots-clés sont déjà présents dans votre CV — aucune reformulation nécessaire.`)
};

const es_keyword_optimizer_no_reformulations = /** @type {(inputs: Keyword_Optimizer_No_ReformulationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todas las palabras clave ya están presentes en tu CV — no se necesita reformulación.`)
};

const it_keyword_optimizer_no_reformulations = /** @type {(inputs: Keyword_Optimizer_No_ReformulationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutte le parole chiave sono già presenti nel tuo CV — nessuna riformulazione necessaria.`)
};

const nl_keyword_optimizer_no_reformulations = /** @type {(inputs: Keyword_Optimizer_No_ReformulationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle zoekwoorden staan al in je CV — geen herformulering nodig.`)
};

const pl_keyword_optimizer_no_reformulations = /** @type {(inputs: Keyword_Optimizer_No_ReformulationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wszystkie słowa kluczowe są już obecne w Twoim CV — przeformułowanie nie jest potrzebne.`)
};

const fi_keyword_optimizer_no_reformulations = /** @type {(inputs: Keyword_Optimizer_No_ReformulationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kaikki avainsanat löytyvät jo ansioluettelostasi — uudelleenmuotoilua ei tarvita.`)
};

const da_keyword_optimizer_no_reformulations = /** @type {(inputs: Keyword_Optimizer_No_ReformulationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle nøgleord findes allerede i dit CV — ingen omformulering nødvendig.`)
};

const sv_keyword_optimizer_no_reformulations = /** @type {(inputs: Keyword_Optimizer_No_ReformulationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alla nyckelord finns redan i ditt CV — ingen omformulering behövs.`)
};

/**
* | output |
* | --- |
* | "All keywords are already present in your resume — no rewording needed." |
*
* @param {Keyword_Optimizer_No_ReformulationsInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const keyword_optimizer_no_reformulations = /** @type {((inputs?: Keyword_Optimizer_No_ReformulationsInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keyword_Optimizer_No_ReformulationsInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_keyword_optimizer_no_reformulations(inputs)
	if (locale === "fr") return fr_keyword_optimizer_no_reformulations(inputs)
	if (locale === "es") return es_keyword_optimizer_no_reformulations(inputs)
	if (locale === "it") return it_keyword_optimizer_no_reformulations(inputs)
	if (locale === "nl") return nl_keyword_optimizer_no_reformulations(inputs)
	if (locale === "pl") return pl_keyword_optimizer_no_reformulations(inputs)
	if (locale === "fi") return fi_keyword_optimizer_no_reformulations(inputs)
	if (locale === "da") return da_keyword_optimizer_no_reformulations(inputs)
	if (locale === "sv") return sv_keyword_optimizer_no_reformulations(inputs)
	return en_keyword_optimizer_no_reformulations(inputs)
});